module.exports = __webpack_public_path__ + "img/guashaxuewei.f31823d6.png";